import { render, staticRenderFns } from "./FormTypes.vue?vue&type=template&id=6ff985b0&scoped=true"
import script from "./FormTypes.vue?vue&type=script&lang=js"
export * from "./FormTypes.vue?vue&type=script&lang=js"
import style0 from "./FormTypes.vue?vue&type=style&index=0&id=6ff985b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff985b0",
  null
  
)

export default component.exports